










































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storePermintaanKerohanian } from "@/store/modules/PermintaanKerohanianStore";
import PermintaanKerohanianSvc from "@/services/permintaanKerohanianService";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { getHumanDateTime } from "@/utility/DateUtils";
import moment from "moment";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardPermintaanKerohanian extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get canCreate(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("permintaan_kerohanian", "create");
  }

  get canEditForm(): boolean {
    if (this.readOnly) return false;
    return userModule.canAccessForm("permintaan_kerohanian", "edit");
  }

  showForm = false;
  showDetail: any = null;
  saving = false;
  formValid = false;
  editId: number | null = null;
  menuTglTtd = false;

  form: any = this.getEmptyForm();

  headers = [
    { text: "Tanggal", value: "tgl_tanda_tangan", width: "120px" },
    { text: "Pemohon", value: "pemohon_nama" },
    { text: "Hubungan", value: "hubungan_pasien", width: "130px" },
    { text: "Agama Dimohon", value: "agama_dimohon", width: "130px" },
    { text: "Status TTD", value: "signed_pemohon", width: "110px" },
    { text: "Aksi", value: "actions", sortable: false, width: "90px" },
  ];

  jkOptions = [
    { text: "Laki-laki", value: "L" },
    { text: "Perempuan", value: "P" },
  ];

  agamaOptions = [
    "Islam", "Kristen", "Katholik", "Hindu", "Budha", "Konghucu", "Lainnya"
  ];

  mounted() {
    storePermintaanKerohanian.getByRegister(this.register);
  }

  getEmptyForm() {
    return {
      pemohon_nama: "",
      pemohon_umur: null as number | null,
      pemohon_jk: null as string | null,
      pemohon_no_hp: "",
      pemohon_agama: null as string | null,
      pemohon_alamat: "",
      hubungan_pasien: null as string | null,
      hubungan_lainnya: "",
      pasien_nama: "",
      pasien_umur: null as number | null,
      pasien_jk: null as string | null,
      pasien_agama: null as string | null,
      pasien_alamat: "",
      agama_dimohon: null as string | null,
      tempat_tanda_tangan: "Bantul",
      tgl_tanda_tangan: moment().format("YYYY-MM-DD"),
    };
  }

  get storeRef() {
    return storePermintaanKerohanian;
  }

  get items() {
    return storePermintaanKerohanian.items;
  }

  get pasienData() {
    return storePasien.identitasPasien;
  }

  formatDate(date) {
    if (!date) return "-";
    const m = moment(date);
    return m.isValid() ? m.format("DD-MM-YYYY") : "-";
  }

  formatDateTime(date) {
    return getHumanDateTime(date);
  }

  formatHubungan(item) {
    const map = {
      diri_sendiri: "Diri Sendiri",
      anak: "Anak",
      istri: "Istri",
      suami: "Suami",
      orang_tua: "Orang Tua",
      lainnya: item.hubungan_lainnya || "Lainnya",
    };
    return map[item.hubungan_pasien] || item.hubungan_pasien;
  }

  formatAgama(agama: string) {
    const map = {
      kristen: "Kristen",
      katholik: "Katholik",
      hindu: "Hindu",
      budha: "Budha",
    };
    return map[agama] || agama;
  }

  normalizeJk(jk: string | null | undefined): string | null {
    if (!jk) return null;
    const v = String(jk).toLowerCase();
    if (v === "l" || v.startsWith("laki")) return "L";
    if (v === "p" || v.startsWith("perempuan")) return "P";
    return null;
  }

  populatePasienData() {
    if (this.pasienData) {
      this.form.pasien_nama = this.pasienData.nama || "";
      this.form.pasien_jk = this.normalizeJk(this.pasienData.jk);
      this.form.pasien_agama = this.pasienData.agama || null;
      this.form.pasien_alamat = this.pasienData.alamat || "";
      if (this.pasienData.tgl_lahir && moment(this.pasienData.tgl_lahir).isValid()) {
        this.form.pasien_umur = moment().diff(moment(this.pasienData.tgl_lahir), "years");
      }
    }
  }

  onHubunganChange(val: string) {
    if (val === "diri_sendiri" && this.pasienData) {
      // Auto-fill pemohon from patient data
      this.form.pemohon_nama = this.pasienData.nama || "";
      this.form.pemohon_jk = this.normalizeJk(this.pasienData.jk);
      this.form.pemohon_agama = this.pasienData.agama || null;
      this.form.pemohon_alamat = this.pasienData.alamat || "";
      if (this.pasienData.tgl_lahir && moment(this.pasienData.tgl_lahir).isValid()) {
        this.form.pemohon_umur = moment().diff(moment(this.pasienData.tgl_lahir), "years");
      }
    }
    // Always populate pasien data from master
    this.populatePasienData();
  }

  tambah() {
    this.form = this.getEmptyForm();
    this.editId = null;
    this.populatePasienData();
    this.showForm = true;
  }

  edit(item) {
    this.editId = item.id;
    this.form = {
      pemohon_nama: item.pemohon_nama || "",
      pemohon_umur: item.pemohon_umur || null,
      pemohon_jk: item.pemohon_jk || null,
      pemohon_no_hp: item.pemohon_no_hp || "",
      pemohon_agama: item.pemohon_agama || null,
      pemohon_alamat: item.pemohon_alamat || "",
      hubungan_pasien: item.hubungan_pasien || null,
      hubungan_lainnya: item.hubungan_lainnya || "",
      pasien_nama: item.pasien_nama || "",
      pasien_umur: item.pasien_umur || null,
      pasien_jk: item.pasien_jk || null,
      pasien_agama: item.pasien_agama || null,
      pasien_alamat: item.pasien_alamat || "",
      agama_dimohon: item.agama_dimohon || null,
      tempat_tanda_tangan: item.tempat_tanda_tangan || "Bantul",
      tgl_tanda_tangan: item.tgl_tanda_tangan || moment().format("YYYY-MM-DD"),
    };
    this.showForm = true;
  }

  lihatDetail(item) {
    this.showDetail = item;
  }

  cancelForm() {
    this.showForm = false;
    this.form = this.getEmptyForm();
    this.editId = null;
  }

  async simpan() {
    this.saving = true;

    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form,
        hubungan_lainnya: this.form.hubungan_pasien === "lainnya"
          ? this.form.hubungan_lainnya
          : null,
      };

      let resp;
      if (this.editId) {
        resp = await PermintaanKerohanianSvc.update(this.editId, payload);
      } else {
        resp = await PermintaanKerohanianSvc.create(payload);
      }

      if (resp.data.status == "1") {
        appModule.NoticeDelay("Permintaan Pelayanan Kerohanian berhasil disimpan");
        this.showForm = false;
        this.form = this.getEmptyForm();
        this.editId = null;
        storePermintaanKerohanian.getByRegister(this.register);
      }
    } finally {
      this.saving = false;
    }
  }

  async tandaiPemohon() {
    try {
      const resp = await PermintaanKerohanianSvc.markPemohon(this.showDetail.id);
      if (resp.data.status == "1") {
        appModule.NoticeDelay("Berhasil menandai tanda tangan pemohon");
        storePermintaanKerohanian.getByRegister(this.register);
        // Refresh detail
        const updated = await PermintaanKerohanianSvc.find(this.showDetail.id);
        if (updated.data.status == "1") {
          this.showDetail = updated.data.data;
        }
      }
    } catch {
      // handled by service
    }
  }

  cetakPdf(item) {
    PermintaanKerohanianSvc.print(item.id);
  }

  async hapus(item) {
    const q = confirm("Anda yakin akan menghapus permintaan pelayanan kerohanian ini?");

    if (q) {
      try {
        const resp = await PermintaanKerohanianSvc.destroy(item.id);
        if (resp?.status == 1) {
          appModule.NoticeDelay(resp.message);
          this.showDetail = null;
          storePermintaanKerohanian.getByRegister(this.register);
        }
      } catch {
        // handled by service
      }
    }
  }
}
